import { ImportConfigurationRepository } from '../data/import-configuration-repository';
import { ColumnMappingRequest, ColumnMappingMutationResponse } from '../types/import-configuration-types';

/**
 * Use case for creating or updating a column mapping
 */
export class SaveColumnMappingUseCase {
  constructor(private readonly repository: ImportConfigurationRepository) {}

  async execute(request: ColumnMappingRequest): Promise<ColumnMappingMutationResponse> {
    return this.repository.saveColumnMapping(request);
  }
}
